import { render, staticRenderFns } from "./MwstAbrechnungView.vue?vue&type=template&id=2727042e"
import script from "./MwstAbrechnungView.vue?vue&type=script&lang=ts"
export * from "./MwstAbrechnungView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports